export const sliderItems = [
  {
    id: 1,
    img: "https://i.ibb.co/QdJwgmp/brown-cowboy.png",
    title: "MENS SUMMER SALE",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "D7BDE2",
    url: "/shop/mens",
  },
  {
    id: 2,
    img: "https://i.ibb.co/s96FpdP/brown-shearling.png",
    title: "WINTER COLLECTION",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "F9E79F",
    url: "/shop/jackets",
  },
  {
    id: 3,
    img: "https://i.ibb.co/cXFnLLV/3.png",
    title: "LOUNGEWEAR LOVE",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "EDBB99",
    url: "/shop/womens",
  },
];
